import {
  ref,
  onValue,
  DataSnapshot,
  get,
  getDatabase,
} from "firebase/database";
import { QueryKeys } from "./query-client";
import { useQuery } from "react-query";
import { EntryData } from "../../constants/model/models";
import * as firebase from "firebase/app";
import { firebaseConfig } from "../../constants/env";
import { i18n } from "next-i18next";

export interface UsefulArticleData extends EntryData {
  name: string;
  tags?: string;
  timestamp: string;
  title: string;
  author: string;
  category: string;
  specialistUrl?: string;
}

export function useUsefulArticleList() {
  if (!firebase.getApps().length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.getApp(); // if already initialized, use that one
  }
  const database = getDatabase(firebase.getApp());
  const publishedBlogsRef = ref(
    database,
    `published/useful-articles/${i18n?.language}`
  );
  const {
    data: articles,
    isFetching: articlesAreLoading,
    isError: articlesError,
  } = useQuery([QueryKeys.USEFUL_ARTICLES], () => getArticles(), {
    keepPreviousData: true,
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  // wrap blog entries subscription into a promise to be used with react-query
  function getEntries(): Promise<Record<string, UsefulArticleData> | null> {
    return new Promise((resolve, reject) => {
      onValue(
        publishedBlogsRef,
        async (snapshot) => {
          const publishedEntries: Record<string, UsefulArticleData> =
            snapshot.val();

          const entries: Record<string, UsefulArticleData> = Object.assign(
            {},
            publishedEntries
          );
          resolve(entries);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async function getArticles(): Promise<UsefulArticleData[]> {
    const data = await getEntries();
    if (data) {
      return Object.keys(data).map((key) => data[key]);
    } else {
      return [];
    }
  }

  return {
    articles,
    articlesAreLoading,
    articlesError,
  };
}
